import cn from 'classnames';
import type { FC, ImgHTMLAttributes, ReactNode } from 'react';

import { isProdBuild } from '@src/utils';

import styles from './styles.module.scss';

type TFit = 'cover' | 'contain' | 'scale-down' | 'crop' | 'pad';

interface IOptimizedPicture {
  img: string;
  alt: string;
  fit?: TFit;
  width?: number;
  height?: number;
  cropWidth?: number;
  cropHeight?: number;
  imgClassName?: string | undefined;
  quality?: number;
  loading?: ImgHTMLAttributes<HTMLImageElement>['loading'];
  fetchpriority?: ImgHTMLAttributes<HTMLImageElement>['fetchpriority'];
  isJpeg?: boolean;
  className?: string;
}

export const OptimizedPicture: FC<IOptimizedPicture> = ({
  className,
  img,
  alt,
  fit = 'cover',
  width,
  height,
  cropWidth,
  cropHeight,
  quality = 95,
  imgClassName,
  isJpeg,
  loading = 'lazy',
  fetchpriority = 'auto',
  ...otherProps
}) => (
  <picture {...otherProps} className={className}>
    {isProdBuild && <source srcSet={img} type="image/avif" />}
    {isProdBuild && <source srcSet={img} type="image/webp" />}

    <img
      className={cn(imgClassName, styles.img)}
      style={{ width, height }}
      alt={alt}
      src={img}
      loading={loading}
      // eslint-disable-next-line react/no-unknown-property
      fetchpriority={fetchpriority}
    />
  </picture>
);
